import "./Drinks.module.css";
import Header from "@/reusable_sections/Header";
import Principles from "./sections/Principles";
import Safety from "./sections/Safety";
import Footer from "@/reusable_sections/Footer";
export default function DrinksPage() {
  return <div>
      <Header />
      <Principles />
      <Safety />
      <Footer />
    </div>;
}